import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    createEsubjectLoading: false,
    createEsubjectSuccess: {},
    createEsubjectError: "",
    listEsubjectLoading: false,
    listEsubjectSuccess: {},
    listEsubjectError: "",
    eSubjectEditDetailsLoading: false,
    eSubjectEditDetailsSuccess: {},
    eSubjectEditDetailsError: '',
    eSubjectViewDetailsLoading: false,
    eSubjectViewDetailsSuccess: {},
    eSubjectViewDetailsError: '',

    eSubjectCratetopicsLoading: false,
    eSubjectCratetopicsSuccess: {},
    eSubjectCratetopicsError: '',

    eSubjectTopicsDetailsLoading: false,
    eSubjectTopicsDetailsSuccess: {},
    eSubjectTopicsDetailsError: '',

    //  sub topics
    eSubjectCrateSubTopicsLoading: false,
    eSubjectCrateSubTopicsSuccess: {},
    eSubjectCrateSubTopicsError: '',

    eSubjectSubTopicsDetailsLoading: false,
    eSubjectSubTopicsDetailsSuccess: {},
    eSubjectSubTopicsDetailsError: '',

    // concept initial state

    eSubjectCrateConceptsLoading: false,
    eSubjectCrateConceptsSuccess: {},
    eSubjectCrateConceptsError: '',

    eSubjectConceptsDetailsLoading: false,
    eSubjectConceptsDetailsSuccess: {},
    eSubjectConceptsDetailsError: '',

}

export const eSubjectsSlice = createSlice({
    name: 'eSubjects',
    initialState,
    reducers: {
        setCreateSubjectLoading: (state, action) => {
            state.createEsubjectLoading = true
        },
        setCreateSubjectSuccess: (state, action) => {
            state.createEsubjectLoading = false
            state.createEsubjectSuccess = action.payload
        },
        setCreateSubjectError: (state, action) => {
            state.createEsubjectLoading = false
            state.createEsubjectSuccess = {}
            state.createEsubjectError = action.payload.message
        },
        setEsubjectListLoading: (state, action) => {
            state.listEsubjectLoading = true
        },
        setEsubjectListSuccess: (state, action) => {
            state.listEsubjectLoading = false
            state.listEsubjectSuccess = action.payload
        },
        setEsubjectListError: (state, action) => {
            state.listEsubjectLoading = false
            state.listEsubjectSuccess = {}
            state.listEsubjectError = action.payload.message
        },
        setEsubjectEditDetails: (state, action) => {
            state.eSubjectEditDetailsLoading = true
        },
        setEsubjectEditDetailsSuccess: (state, action) => {
            state.eSubjectEditDetailsLoading = false
            state.eSubjectEditDetailsSuccess = action.payload.data

        },
        setEsubjectEditDetailsError: (state, action) => {
            state.eSubjectEditDetailsLoading = false
            state.eSubjectEditDetailsSuccess = {}
            state.eSubjectEditDetailsError = action.payload.message
        },

        setEsubjectViewDetailsLoading: (state, action) => {
            state.eSubjectViewDetailsLoading = true


        },
        setEsubjectViewDetailsSuccess: (state, action) => {
            state.eSubjectViewDetailsLoading = false
            state.eSubjectViewDetailsSuccess = action.payload
            state.eSubjectViewDetailsError = ''
        },
        setEsubjectViewDetailsError: (state, action) => {
            state.eSubjectViewDetailsLoading = false
            state.eSubjectViewDetailsSuccess = {}
            state.eSubjectViewDetailsError = action.payload.message
        },

        setEsubjectTopicCreateLoading: (state, action) => {
            state.eSubjectCratetopicsLoading = true
            state.eSubjectCratetopicsSuccess = {}
        },
        setEsubjectTopicCreateSuccess: (state, action) => {
            state.eSubjectCratetopicsLoading = false
            state.eSubjectCratetopicsSuccess = action.payload
        },

        setEsubjectTopicCreateError: (state, action) => {
            state.eSubjectCratetopicsLoading = false
            state.eSubjectCratetopicsSuccess = {}
            state.eSubjectCratetopicsError = action.payload.message
        },

        setEsubjectTopicsDetailsLoading: (state, action) => {
            state.eSubjectTopicsDetailsLoading = true
            state.eSubjectTopicsDetailsSuccess = {}
        },
        setEsubjectTopicsDetailsSuccess: (state, action) => {
            state.eSubjectTopicsDetailsLoading = false
            state.eSubjectTopicsDetailsSuccess = action.payload.data
        },
        setEsubjectTopicDetailsError: (state, action) => {
            state.eSubjectTopicsDetailsLoading = false
            state.eSubjectTopicsDetailsSuccess = {}
            state.eSubjectTopicsDetailsError = action.payload.message
        },
        // sub topics reducer

        setEsubjectCreateSubtopicLoading: (state, action) => {
            state.eSubjectCrateSubTopicsLoading = true
        },
        setEsubjectCreateSubtopicSuccess: (state, action) => {
            state.eSubjectCrateSubTopicsLoading = false
            state.eSubjectCrateSubTopicsSuccess = action.payload

        },
        setEsubjectCreateSubtopicError: (state, action) => {
            state.eSubjectCrateSubTopicsLoading = false
            state.eSubjectCrateSubTopicsSuccess = {}
            state.eSubjectCrateSubTopicsError = action.payload.message
        },

        setEsubjectDetailsSubtopicLoading: (state, action) => {
            state.eSubjectSubTopicsDetailsLoading = true
        },
        setEsubjectDetailsSubtopicSuccess: (state, action) => {
            state.eSubjectSubTopicsDetailsLoading = false
            state.eSubjectSubTopicsDetailsSuccess = action.payload.data

        },
        setEsubjectDetailsSubtopicError: (state, action) => {
            state.eSubjectSubTopicsDetailsLoading = false
            state.eSubjectSubTopicsDetailsSuccess = {}
            state.eSubjectSubTopicsDetailsError = action.payload.message
        },
        // concepts reducer


        setEsubjectCreateConceptLoading: (state, action) => {
            state.eSubjectCrateConceptsLoading = true
        },
        setEsubjectCreateConceptSuccess: (state, action) => {
            state.eSubjectCrateConceptsLoading = false
            state.eSubjectCrateConceptsSuccess = action.payload

        },
        setEsubjectCreateConceptError: (state, action) => {
            state.eSubjectCrateConceptsLoading = false
            state.eSubjectCrateConceptsSuccess = {}
            state.eSubjectCrateConceptsError = action.payload.message
        },

        setEsubjectDetailsConceptLoading: (state, action) => {
            state.eSubjectConceptsDetailsLoading = true
        },
        setEsubjectDetailsConceptSuccess: (state, action) => {
            state.eSubjectConceptsDetailsLoading = false
            state.eSubjectConceptsDetailsSuccess = action.payload.data

        },
        setEsubjectDetailsConceptError: (state, action) => {
            state.eSubjectConceptsDetailsLoading = false
            state.eSubjectConceptsDetailsSuccess = {}
            state.eSubjectConceptsDetailsError = action.payload.message
        },




        resetDetails: (state, action) => {
            state.createEsubjectLoading = false
            state.createEsubjectSuccess = {}
            state.createEsubjectError = ""
            state.eSubjectEditDetailsLoading = false
            state.eSubjectEditDetailsSuccess = {}
            state.eSubjectEditDetailsError = ""
        },
        resetETopicsFormDetails: (state, action) => {
            state.eSubjectCratetopicsLoading = false
            state.eSubjectCratetopicsSuccess = {}
            state.eSubjectCratetopicsError = ""
            state.eSubjectTopicsDetailsLoading = false
            state.eSubjectTopicsDetailsSuccess = {}
            state.eSubjectTopicsDetailsError = ""
        },
        resetESubtopicFormDetails: (state, action) => {
            state.eSubjectCrateSubTopicsLoading = false
            state.eSubjectCrateSubTopicsSuccess = {}
            state.eSubjectCrateSubTopicsError = ""
            state.eSubjectSubTopicsDetailsLoading = false
            state.eSubjectSubTopicsDetailsSuccess = {}
            state.eSubjectSubTopicsDetailsError = ""
        },
        resetEConceptsDetails: (state, action) => {
            state.eSubjectCrateConceptsLoading = false
            state.eSubjectCrateConceptsSuccess = {}
            state.eSubjectCrateConceptsError = ""
            state.eSubjectConceptsDetailsLoading = false
            state.eSubjectConceptsDetailsSuccess = {}
            state.eSubjectConceptsDetailsError = ""
        }

    },

})

// Action creators are generated for each case reducer function
export const {
    resetDetails,
    resetETopicsFormDetails,
    setCreateSubjectLoading,
    setCreateSubjectSuccess,
    setCreateSubjectError,
    setEsubjectListLoading,
    setEsubjectListSuccess,
    setEsubjectListError,
    setEsubjectEditDetails,
    setEsubjectEditDetailsSuccess,
    setEsubjectEditDetailsError,
    setEsubjectViewDetailsLoading,
    setEsubjectViewDetailsSuccess,
    setEsubjectViewDetailsError,
    setEsubjectTopicCreateLoading,
    setEsubjectTopicCreateSuccess,
    setEsubjectTopicCreateError,
    setEsubjectTopicsDetailsLoading,
    setEsubjectTopicsDetailsSuccess,
    setEsubjectTopicDetailsError,
    setEsubjectCreateSubtopicLoading,
    setEsubjectCreateSubtopicSuccess,
    setEsubjectCreateSubtopicError,
    setEsubjectDetailsSubtopicLoading,
    setEsubjectDetailsSubtopicSuccess,
    setEsubjectDetailsSubtopicError,
    setEsubjectCreateConceptLoading,
    setEsubjectCreateConceptSuccess,
    setEsubjectCreateConceptError,
    setEsubjectDetailsConceptLoading,
    setEsubjectDetailsConceptSuccess,
    setEsubjectDetailsConceptError,
    resetESubtopicFormDetails,
    resetEConceptsDetails



} = eSubjectsSlice.actions

export default eSubjectsSlice.reducer;